export const BussList = ["Constructions", "Infrastructure", "IT", "All", "About"];

// export default BussList;
